import { List } from './list';
import { CacheService } from '../services/cache.service';

export class ListCached<T> extends List<T> {

  protected listName: string;

  constructor(
    listName: string,
    private cacheService: CacheService
  ) {
    super();
    this.listName = `${listName}-cached`;
    this.restore();
  }

  public restore(): void {
    const value = this.cacheService.session(this.listName);
    if (Array.isArray(value)) {
      this.target = value;
    }
  }

  public add(value: T): void {
    if (!this.target.includes(value)) {
      this.target.push(value);
      this.cacheService.saveSession(this.listName, this.target);
    }
  }

  public remove(value: T): void {
    if (this.target.includes(value)) {
      const index = this.target.indexOf(value);
      this.target.splice(index, 1);
      this.cacheService.saveSession(this.listName, this.target);
    }
  }
}
